import React from 'react';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { EnterNowButton } from '@sections/rachel-zoe/components/EnterNowButton';
import { getRootUrl } from '@utils/urlHelpers.util';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { Curation } from './Curation';
import { curationsData } from './CuratedRegistrySection.constants';
import { DisplayAboveMobile, DisplayOnMobile } from './CuratedRegistrySection.styles';

const rachelZoeCuratedRegistryData = rachelZoePageData.sections.curatedRegistry;

export const CuratedRegistrySection: React.FC = () => {
  return (
    <Box as="section" id="Rachel_Zoe_Curated_Registry" paddingTop={11} paddingBottom={12} marginTop={[0, 6]}>
      <DisplayAboveMobile>
        <TextPairing
          eyebrow={rachelZoeCuratedRegistryData.heading.eyebrow}
          eyebrowVariant="sectionEyeBrow24"
          eyebrowColor="neutra5"
          eyebrowTagName="h3"
          title={rachelZoeCuratedRegistryData.heading.title}
          titleVariant="hed96Break"
          titleColor="neutra6"
          titleTagName="h2"
          marginBottom={12}
          alignment="center"
        />
        <TextPairing
          eyebrow={rachelZoeCuratedRegistryData.subHeading.eyebrow}
          eyebrowVariant="sectionEyeBrow20"
          eyebrowColor="neutra5"
          eyebrowTagName="h3"
          title={rachelZoeCuratedRegistryData.subHeading.title}
          titleVariant="hed56"
          titleColor="neutra6"
          titleTagName="h2"
          body={rachelZoeCuratedRegistryData.subHeading.body}
          bodyVariant="dek24"
          bodyColor="neutra5"
          bodyMaxWidth="575px"
          alignment="center"
        />
      </DisplayAboveMobile>
      <DisplayOnMobile>
        <TextPairing
          eyebrow={rachelZoeCuratedRegistryData.heading.eyebrow}
          eyebrowVariant="sectionEyeBrow24"
          eyebrowColor="humanaDark4"
          eyebrowTagName="h3"
          title={rachelZoeCuratedRegistryData.heading.title}
          titleVariant="hed120Super"
          titleColor="neutra6"
          titleTagName="h2"
          titleMaxWidth="60%"
          bodyVariant="dek24"
          marginBottom={11}
          alignment="center"
        />
        <TextPairing
          eyebrow={rachelZoeCuratedRegistryData.subHeading.eyebrow}
          eyebrowVariant="featureHed17"
          eyebrowTagName="h3"
          title=""
          titleVariant="hed40"
          bodyVariant="dek20"
          eyebrowColor="neutra5"
          alignment="center"
        />
        <TextPairing
          title={rachelZoeCuratedRegistryData.subHeading.title}
          titleVariant="calloutHed32"
          titleColor="neutra6"
          titleTagName="h2"
          body={rachelZoeCuratedRegistryData.subHeading.body}
          bodyVariant="featureCopy17"
          bodyColor="neutra5"
          bodyMaxWidth="315px"
          marginBottom={9}
          alignment="center"
        />
      </DisplayOnMobile>
      <Box marginTop={[9, 11]}>
        {curationsData.map((curation, index) => (
          <Curation
            key={index + curation.pageUrl}
            videoImages={{ ...curation.videoImages, ...rachelZoeCuratedRegistryData.curationVideoUrls[index] }}
            pageUrl={curation.pageUrl}
            marginBottom={curation.marginBottom}
          />
        ))}
      </Box>
      <Box marginY={10} style={{ textAlign: 'center' }}>
        <EnterNowButton id="curatedRegistryViewTheCollectionAndEnterNow" href={getRootUrl('/shop')} variant="defaultPrimary">
          {rachelZoeCuratedRegistryData.ctaText}
        </EnterNowButton>
      </Box>
    </Box>
  );
};
